"use strict";

var curryN = require('../function/curryN');
/**
 * Checks if a string starts with the provided prefix
 *
 * @param {string} prefix
 * @param {string} str
 * @return {Boolean}
 * @example
 *
 *      startsWith('a', 'abc')                //=> true
 *      startsWith('b', 'abc')                //=> false
 */
module.exports = curryN(2, function (prefix, str) {
  if (prefix === void 0) {
    prefix = '';
  }
  if (str === void 0) {
    str = '';
  }
  return str.slice(0, prefix.length) === prefix;
});